// /security calls (jobq-api "AFTER-HOURS SECURITY", since 2026-10-13).
//
// The shared API key ships in this bundle, so jobq-api never takes it alone on a /security route:
// an admin's call also carries their Admin PIN (X-Admin-Pin), which the API checks itself (bcrypt,
// role Admin, rate-limited per IP). The PIN is the admin session's (sessionStorage adminPin, set by
// the admin unlock in adminSession.jsx). Use securityFetch for EVERY /security call from the UI.
// The camera Pi's routes (GET /security/armed, POST /security/incidents, /presence/auto_leave)
// take only the Pi's own key: the UI cannot call them.

import { beaconFetch } from './beacons';

/** The admin session's PIN, or null when this tab has no admin unlock. */
export function adminPinFromSession() {
  try {
    const role = (sessionStorage.getItem('userRole') || '').toLowerCase();
    const pin = sessionStorage.getItem('adminPin');
    return role === 'admin' && pin ? pin : null;
  } catch (_) {
    return null;
  }
}

/** beaconFetch plus X-Admin-Pin. Resolves {ok, status, body, message}; never throws. */
export function securityFetch(path, opts = {}) {
  const pin = adminPinFromSession();
  return beaconFetch(path, {
    ...opts,
    headers: { ...(opts.headers || {}), ...(pin ? { 'X-Admin-Pin': pin } : {}) },
  });
}

/** The API refused the admin PIN (missing, wrong, or not an Admin's). */
export function needsAdminPin(res) {
  return !!res && (res.status === 401 || res.status === 403);
}
